(() => {
  const LABEL_SELECTOR =
    '.product__info-container .jdgm-prev-badge__text';
  const REVIEW_LABEL_PATTERN = /^([\d,.]+)\s+reviews?$/i;

  function formatReviewLabel(sourceText) {
    const match = sourceText.match(REVIEW_LABEL_PATTERN);
    if (!match) return null;

    return `${match[1]} REVIEWS`;
  }

  function normalizeLabel(label) {
    const currentText = label.textContent.replace(/\s+/g, ' ').trim();
    if (!currentText) return;

    const storedSourceText = label.dataset.pdpReviewSourceText;
    const storedVisibleText = storedSourceText
      ? formatReviewLabel(storedSourceText)
      : null;
    const sourceText =
      storedSourceText &&
      (currentText === storedVisibleText || currentText === 'REVIEWS')
        ? storedSourceText
        : currentText;
    const visibleText = formatReviewLabel(sourceText);

    if (!visibleText) return;

    label.dataset.pdpReviewSourceText = sourceText;
    label.setAttribute('aria-label', sourceText);
    if (currentText !== visibleText) label.textContent = visibleText;
  }

  function normalizeLabels(root = document) {
    if (!root) return;
    if (root.matches?.(LABEL_SELECTOR)) normalizeLabel(root);
    root.querySelectorAll?.(LABEL_SELECTOR).forEach(normalizeLabel);
  }

  function init() {
    normalizeLabels();

    const observer = new MutationObserver((records) => {
      records.forEach((record) => {
        if (record.type === 'characterData') {
          normalizeLabels(record.target.parentElement);
          return;
        }

        record.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            normalizeLabels(node);
          } else if (node.nodeType === Node.TEXT_NODE) {
            normalizeLabels(node.parentElement);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
